module.exports = (__webpack_require__(3))(22);


//////////////////
// WEBPACK FOOTER
// delegated ./src/auth.js from dll-reference girder_plugin_large_image_annotation
// module id = 9
// module chunks = 0